export const DEFAULT_STRUCTURE = {
  '@context': 'https://schema.org' as const,
};
